module.exports = __webpack_public_path__ + "img/calendar.277714a5.svg";